<template>
    <div>
        <Card>
            <p slot="title">数据同步计划</p>
            <Table :columns="column1" :data="lists">
                <template slot-scope="{ index }" slot="action">
                    <Button type="primary" size="small" style="margin-right: 5px" @click="ActionHandle(index)">操作</Button>
                    <Button type="info" size="small" style="margin-right: 5px" @click="ExecuteHandle(index)">执行</Button>
                </template>
            </Table>
        </Card>
        <Modal
          v-model="modal"
          title="同步数据设置"
          :loading="loading"
          @on-ok="handleSubmit('formValidate')"
          >
          <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" @submit.native.prevent>
            <FormItem label="同步名称">
              <Input v-model="formValidate.cKeyName" readonly/>
            </FormItem>
            <FormItem label="同步间隔(分钟)" prop="PlanTimeLength">
              <InputNumber :min="1" :step="1" v-model="formValidate.PlanTimeLength" :precision="0"></InputNumber>
            </FormItem>
            <FormItem label="最后同步时间">
              <Input v-model="formValidate.LastTime" readonly/>
            </FormItem>
            <FormItem label="已运行次数">
              <Input v-model="formValidate.TotalNum" readonly/>
            </FormItem>
            <FormItem label="状态" prop="UseState">
              <Select v-model="formValidate.UseState">
                  <Option v-for="item in statelist" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Form>
        </Modal>
    </div>
</template>

<script>
import { GetPlanTaskExecuteData, UpdateTaskExecuteDataCkey, TaskExecute } from '@/api/DataSync'
export default {
  name: 'DataSync-BaseSet-SyncSet',
  data () {
    return {
      column1: [
        {
          title: '同步名称',
          key: 'cKeyName'
        }, {
          title: '同步间隔(分钟)',
          key: 'PlanTimeLength'
        }, {
          title: '最后同步时间',
          key: 'LastTime'
        }, {
          title: '已运行次数',
          key: 'TotalNum'
        }, {
          title: '状态',
          key: 'UseState'
        }, {
          title: '操作',
          slot: 'action',
          width: 150,
          align: 'center'
        }],
      lists: [],
      modal: false,
      loading: true,
      formValidate: {
        AutoID: 0,
        cKeyName: '',
        PlanTimeLength: 0,
        LastTime: '',
        TotalNum: 0,
        UseState: ''
      },
      statelist: [
        {
          value: '运行中',
          label: '运行中'
        }, {
          value: '停用',
          label: '停用'
        }, {
          value: '异常',
          label: '异常'
        }],
      ruleValidate: {
        PlanTimeLength: [
          { type: 'integer', required: true, min: 1, message: '请输入时间间隔', trigger: 'blur' }
        ],
        UseState: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    }
  },
  mounted: function () {
    this.GetPlanTaskExecuteList()
  },
  methods: {
    // 获取同步数据计划表
    GetPlanTaskExecuteList () {
      GetPlanTaskExecuteData().then(res => {
        if (res.IsSuccess) {
          this.lists = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 点击操作回调
    ActionHandle (index) {
      this.formValidate = {
        AutoID: this.lists[index].AutoID,
        cKeyName: this.lists[index].cKeyName,
        PlanTimeLength: this.lists[index].PlanTimeLength,
        LastTime: this.lists[index].LastTime,
        TotalNum: this.lists[index].TotalNum,
        UseState: this.lists[index].UseState
      }
      this.modal = true
    },
    // 点击提交回调
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          UpdateTaskExecuteDataCkey({
            AutoID: this.formValidate.AutoID,
            PlanTimeLength: this.formValidate.PlanTimeLength,
            UseState: this.formValidate.UseState
          }).then(res => {
            if (res.IsSuccess) {
              this.modal = false
              this.$Message.success('提交成功!')
              this.GetPlanTaskExecuteList()
            } else {
              this.$Message.error(res.Message)
            }
          })
        } else {
          this.$Message.error('提交失败，请先完善数据后再提交。')
          this.loading = false
          setTimeout(() => {
            this.loading = true
          }, 100)
        }
      })
    },
    // 执行回调
    ExecuteHandle (index) {
      const AutoID = this.lists[index].AutoID
      TaskExecute(AutoID).then(res => {
        if (res.IsSuccess) {
          this.$Message.success('执行成功!')
          this.GetPlanTaskExecuteList()
        } else {
          this.$Message.error(res.Message)
        }
      })
    }
  }
}
</script>
